import React, { useContext, useEffect } from "react"
import Context from "../../utils/Context"
import Network from "../../components/Network"
import ROSFunctions from "../../utils/ROS/ROSFunctions"
import ModalTask from "../../components/ModalTask"
import ModalMission from "../../components/ModalMission"
import ModalImport from "../../components/ModalImport"
import ModalTrigger from "../../components/ModalTrigger"
import ModalDistribution from "../../components/ModalDistribution"
import ModalCollect from "../../components/ModalCollect"
import ModalConfiguration from "../../components/ModalConfiguration"
import RobotMenu from "../../components/RobotMenu"
import GlobalModal from "../../components/GlobalModal"
import ModalAlerts from "../../components/ModalAlerts"
import SettingsRemote from "../../components/SettingsRemote"
import history from "../../utils/history"
import api from "../../api/api"
import ModalVerification from "../../components/ModalVerification"

const Home = () => {
  const context = useContext(Context)

  const fetchMaps = async () => {
    let res

    res = await api.fetchMaps({ syncFMS: true })

    if (res?.data) context.actions.setMaps(res.data)
  }

  if (context.settings.fmsConnection && !context.apiToken) {
    history.push("/login")
  }

  useEffect(() => {
    if (context.settings.fmsConnection && context.apiToken) {
      fetchMaps()
    }
  }, [context.apiToken])

  return (
    <div>
      <ROSFunctions />
      <Network />
      {context.modalState.settingsRemote && <SettingsRemote />}
      <RobotMenu />
      {context.modalState.configuration && <ModalConfiguration />}
      <GlobalModal />
      {context.modalState.tasks && <ModalTask />}
      {context.modalState.missions && <ModalMission />}
      {context.modalState.distribution && <ModalDistribution />}
      {context.modalState.collect && <ModalCollect />}
      {context.modalState.trigger && <ModalTrigger />}
      {context.modalState.verification && <ModalVerification />}
      {context.modalState.disconnect && (context.errorMessage || context.robotStatus || context.diagnostic) && <ModalAlerts />}
      {context.modalState.import && <ModalImport />}
    </div>
  )
}

export default Home
